<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("create_insurer") }}</template>
		</core-layout-headline-and-actions>

		<!-- Body -->
		<j-card class="xs-12 bg5 r2 p4">
			<!-- Id -->
			<div class="xs-12">
				<label for="id" class="block xs-12 lh125 fw7 mb1">{{ $t("id") }}</label>
				<span class="xs-12 lh125 fs3 mb1">{{ $t("has_to_be_unique") }}</span>
				<j-base-input-text
					id="id"
					name="id"
					v-validate="{ required: true, alphanumeric_underscore: true }"
					:status="errors.first('id') ? 'error' : null"
					v-model="form.id"
				/>
				<span class="fs3 lh125 mt1 cError">{{ errors.first("id") }}</span>
			</div>

			<!-- Name -->
			<div class="xs-12 mt6">
				<label for="name" class="block xs-12 lh125 fw7 mb1 mt4">
					{{ $t("name") }}
				</label>
				<j-base-input-text
					id="name"
					name="name"
					v-validate="'required'"
					:status="errors.first('name') ? 'error' : null"
					v-model="form.name"
				/>
				<span class="fs3 lh125 mt1 cError">{{ errors.first("name") }}</span>
			</div>

			<!-- DetailedName -->
			<div class="xs-12 mt6">
				<label for="detailedName" class="block xs-12 lh125 fw7 mb1 mt4">
					{{ $t("detailedName") }}
				</label>
				<j-base-input-text
					id="detailedName"
					name="detailedName"
					v-model="form.detailedName"
				/>
				<span class="fs3 lh125 mt1 cError">
					{{ errors.first("detailedName") }}
				</span>
			</div>

			<!-- Buttons -->
			<div class="mt6">
				<!-- Back Button -->
				<j-button type="secondary" class="mr2" @click="$router.back()">{{
					$t("back")
				}}</j-button>
				<j-button :isLoading="isLoading" @click="handleSubmit">
					{{ $t("create_insurer") }}
				</j-button>
			</div>
		</j-card>
	</core-layout-content>
</template>

<script>
import JCard from "@/components/JCard/"
import JBaseInputText from "@/components/JBaseInputText/"
import JButton from "@/components/JButton/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import api from "../api/"

export default {
	components: {
		JCard,
		JBaseInputText,
		JButton,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions
	},

	data: () => ({
		isLoading: false,

		form: {
			id: null,
			name: null,
			detailedName: null
		}
	}),

	methods: {
		async handleSubmit() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			const { id, name, detailedName } = this.form
			this.isLoading = true
			const res = await api.createInsurer({
				insurer: {
					id: id
				}
			})
			this.isLoading = false
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			let calls = []
			const updateName = () =>
				api.localizeInsurer({
					l10n: {
						locale: "en-US",
						key: `insurers-${id}-name`,
						value: name
					}
				})
			calls.push(updateName())

			if (detailedName != null) {
				const updateDetailedName = () =>
					api.localizeInsurer({
						l10n: {
							locale: "en-US",
							key: `insurers-${id}-detailedName`,
							value: detailedName
						}
					})

				calls.push(updateDetailedName())
			}

			this.isLoading = true
			const results = await Promise.all(calls)
			let errors = []
			results.forEach(r => {
				if (r.data.upsertL10n.errors) {
					errors.push(r.data.upsertL10n.errors)
				}
			})
			this.isLoading = false

			if (errors.length > 0) {
				this.$store.dispatch("showError", errors)
				return
			}

			this.$store.dispatch("addMessage", {
				message: { type: "success", text: "Insurer Creation Successful!" }
			})

			this.$router.push({
				name: "InsurersList"
			})
		}
	}
}
</script>
